'use client'

import { CodeIcon } from 'lucide-react'
import { useEditorContext } from '@/components/ui/editor'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { Button } from '@/components/ui/button'

type PropsType = {
  sourceMode: boolean
  setSourceMode: (value: boolean) => void
  sourceCode: string
  setSourceCode: (value: string) => void
}

const SourceMode = ({ sourceMode, setSourceMode, sourceCode, setSourceCode }: PropsType) => {
  const { editor } = useEditorContext()

  const toggle = () => {
    if (!editor) {
      return
    }

    if (sourceMode) {
      editor.commands.setContent(sourceCode, { emitUpdate: true })
      setSourceMode(false)
    } else {
      setSourceCode(editor.getHTML())
      setSourceMode(true)
    }
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          size="sm"
          variant={sourceMode ? 'default' : 'ghost'}
          onClick={toggle}
          title={sourceMode ? 'WYSIWYG mode' : 'Source code mode'}
          tabIndex={-1}>
          <CodeIcon />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>{sourceMode ? 'WYSIWYG mode' : 'Source code mode'}</p>
      </TooltipContent>
    </Tooltip>
  )
}

export default SourceMode
